import { render, staticRenderFns } from "./bindHotel.vue?vue&type=template&id=67f2d024&scoped=true&"
import script from "./bindHotel.vue?vue&type=script&lang=js&"
export * from "./bindHotel.vue?vue&type=script&lang=js&"
import style0 from "./bindHotel.vue?vue&type=style&index=0&id=67f2d024&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f2d024",
  null
  
)

export default component.exports